// An API call that answered with an error status. Pure, no runtime imports: node:test loads it directly.

export class ApiError extends Error {
  status: number

  constructor(message: string, status: number) {
    super(message)
    this.name = 'ApiError'
    this.status = status
  }
}

/** The call answered 404: what was asked for does not exist (yet). */
export function isNotFound(error: unknown): boolean {
  return error instanceof ApiError && error.status === 404
}
